var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NotFound',{attrs:{"type":"ok","btn":"publicar","btnFunction":_vm.handlePublicar,"title":"Publicar","text":"Esta alocação estará pública. Atenção: Caso já exista uma alocação pública, será removida e substituída por esta."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }